export const getRowTitle = (title, rowIndex, rowsLength) =>
  rowsLength > 1 ? `${title} (${rowIndex + 1} of ${rowsLength})` : title;

export const getRepeatingPanelUntranslatedTitle = (title, fallbackTitle) =>
  typeof title === 'string' ? title.replace(/\(\d*\s*\S*\s*\d*\)/gi, '') : fallbackTitle;
